import Actions from './Actions.container';

export default Actions;
